import { createFileRoute } from "@tanstack/react-router"

import { clientsSettingsSearchSchema } from "@/features/clients/clients-search-schema"
import { Perm } from "@/lib/permissions"
import { requirePermission } from "@/lib/route-guards"
import { SettingsClientsPage } from "@/pages/settings/clients"

export const Route = createFileRoute("/_authenticated/settings/clients")({
  validateSearch: (search) => clientsSettingsSearchSchema.parse(search),
  beforeLoad: async ({ context }) => {
    await requirePermission(context, Perm.CLIENT_READ, { to: "/settings/general" })
  },
  component: SettingsClientsPage,
})
